// A location change with no page load (#808).
//
// Every destination is still its own page load: the rail's entries are links. The one
// exception is the Inbox, whose filter and drawer live in the query so that a context
// selected to answer an item survives the console's remount under it (`inboxView.ts`).
// Changing the query must not reload the page — that is the point of the drawer — so
// `navigate` replaces the history entry and tells `useLocation` to read it again.

import { useEffect, useState } from "react";

const MOVED = "torquenext:location";

/** Replace the location with `path`, and re-render whatever reads it. */
export function navigate(path: string): void {
  window.history.replaceState(window.history.state, "", path);
  window.dispatchEvent(new Event(MOVED));
}

/** The browser's location, read again whenever `navigate` or the history moves it. */
export function useLocation(): { pathname: string; search: string; hash: string } {
  const [, setMoves] = useState(0);
  useEffect(() => {
    const moved = () => setMoves((count) => count + 1);
    window.addEventListener(MOVED, moved);
    window.addEventListener("popstate", moved);
    return () => {
      window.removeEventListener(MOVED, moved);
      window.removeEventListener("popstate", moved);
    };
  }, []);
  return {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
  };
}
